import React from 'react';
import './EventTypeBadge.css';
import locationIcon from './../../../assets/icons/ui/locationVersion.svg';

interface EventTypeBadgeProps {
  type: string; 
}

const EventTypeBadge: React.FC<EventTypeBadgeProps> = ({ type  }) => {
  return (
    <p     className="type-badge">
      <img src={locationIcon} alt="type" className="type-icon" />
      {type}
    </p>
  );
};

export default EventTypeBadge;
